/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareLetterV = createReactComponent("square-letter-v", "IconSquareLetterV", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 8l2 8l2 -8", key: "svg-1" }]
]);

export { IconSquareLetterV as default };
//# sourceMappingURL=IconSquareLetterV.js.map
